// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mvUw","question":"styles_question__1dCrz","description":"styles_description__2Sy3x"};